/**
 * Liens des stores affichés sur la page /t (client qui tape la puce sans avoir l'app).
 *
 * À COMPLÉTER par le propriétaire quand l'app sera publiée (puis `npm run build` /
 * `npm run build:preprod` et redéploiement du hosting) :
 *   - APP_STORE_URL : lien de la fiche App Store, ex. https://apps.apple.com/fr/app/atable/id0000000000
 *     (App Store Connect → l'app → Informations sur l'app → « Afficher sur l'App Store »).
 *   - PLAY_STORE_URL : lien de la fiche Google Play, ex.
 *     https://play.google.com/store/apps/details?id=fr.atthetable.app
 *     (paquet Android de prod, apps/mobile/app.config.ts). La page y ajoute elle-même
 *     `referrer=claim%3D<code de bienvenue>` : l'app lit ce code au premier lancement.
 *
 * Tant qu'un lien est vide, la page affiche « Bientôt disponible » à la place du bouton.
 * Seuls des liens https vers apps.apple.com / play.google.com sont acceptés (storeLinks).
 */
export const APP_STORE_URL = '';
export const PLAY_STORE_URL = '';

/**
 * Politique de confidentialité (lien « Confidentialité » du pied de la page /t), ex.
 * https://atable.fr/confidentialite. Vide tant qu'elle n'est pas publiée : pas de lien.
 */
export const PRIVACY_POLICY_URL = '';
